import { gql } from "@apollo/client";

export const GET_MY_ACCOUNTS = gql`
  query myAccounts {
    myAccounts {
      id
      name
      email
      isOwn
      role
    }
  }
`;

/** What the person may do in the account they are in; see useAccountAccess. */
export const GET_MY_ACCESS = gql`
  query myAccess {
    myAccess {
      isOwner
      role
      applicationIds
      permissions
    }
  }
`;

export const GET_TEAM = gql`
  query team {
    team {
      members {
        id
        userId
        name
        email
        lastActive
        createdAt
        role
        allApps
        applicationIds
      }
      pendingInvites {
        id
        email
        status
        expiresAt
        createdAt
        role
        allApps
        applicationIds
        inviteUrl
      }
    }
  }
`;

export const GET_TEAM_INVITE_PREVIEW = gql`
  query teamInvitePreview($token: String!) {
    teamInvitePreview(token: $token) {
      accountName
      email
      invitedByEmail
      expired
    }
  }
`;

export const INVITE_TEAM_MEMBER = gql`
  mutation inviteTeamMember($email: String!, $access: TeamAccessInput) {
    inviteTeamMember(email: $email, access: $access) {
      id
      email
      status
      expiresAt
      createdAt
      role
      allApps
      applicationIds
      inviteUrl
    }
  }
`;

export const UPDATE_TEAM_MEMBER = gql`
  mutation updateTeamMember($id: Int!, $access: TeamAccessInput!) {
    updateTeamMember(id: $id, access: $access) {
      id
      role
      allApps
      applicationIds
    }
  }
`;

export const REVOKE_TEAM_INVITE = gql`
  mutation revokeTeamInvite($id: ID!) {
    revokeTeamInvite(id: $id)
  }
`;

export const RESEND_TEAM_INVITE = gql`
  mutation resendTeamInvite($id: ID!) {
    resendTeamInvite(id: $id) {
      id
      email
      status
      expiresAt
      createdAt
      role
      allApps
      applicationIds
      inviteUrl
    }
  }
`;

export const ACCEPT_TEAM_INVITE = gql`
  mutation acceptTeamInvite($token: String!) {
    acceptTeamInvite(token: $token) {
      id
      name
      email
      isOwn
      role
    }
  }
`;

export const REMOVE_TEAM_MEMBER = gql`
  mutation removeTeamMember($id: Int!) {
    removeTeamMember(id: $id)
  }
`;

export const LEAVE_TEAM_ACCOUNT = gql`
  mutation leaveTeamAccount($ownerId: Int!) {
    leaveTeamAccount(ownerId: $ownerId)
  }
`;

/**
 * The account's apps for the App Access list. One row per country: the team
 * screen folds them into one item per app, and granting any row of an app
 * grants the whole app on the backend.
 */
export const GET_TEAM_APPS = gql`
  query teamApps {
    getUserConnectedApps {
      id
      appId
      store
      title
      icon
    }
  }
`;
